module.exports = __webpack_public_path__ + "img/feixinjiaju8.0db127d8.jpg";